import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await api.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google sign-in: AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);

  useEffect(() => {
    const onUnauth = () => setUser(false);
    window.addEventListener("cq:unauthorized", onUnauth);
    return () => window.removeEventListener("cq:unauthorized", onUnauth);
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* cookies are cleared server-side; local state is cleared regardless */ }
    localStorage.removeItem("cq_ws");
    sessionStorage.removeItem("cq_next");
    setUser(false);
    // Full navigation drops every cached query so no workspace data survives sign-out.
    window.location.replace("/login");
  };

  return <AuthContext.Provider value={{ user, setUser, logout, check }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
